import { render, staticRenderFns } from "./TraxTrainingCompetencyIndexCrud.vue?vue&type=template&id=fcad8cbc"
import script from "./TraxTrainingCompetencyIndexCrud.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCompetencyIndexCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports